import { Box, Button, CardMedia, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Item } from './index';
import { ApplicationProps, Document } from '../../redux-store/types/api-types';
import { documentDetails } from '../investors/documentDetails';
import { useDispatch } from 'react-redux';
import { getDocuments } from '../../redux-store/actions/application';
import { APPLICATION_TYPE_FOR_DOCUMENTS } from '../../utils/constant';
import { documentProps } from '../investors/PhygitalDocumentDetails';
export default function PhygitalDocumentDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const dispatch = useDispatch();
  const { signedLeegalityFile } = application;
  const [documentsData, setDocumentsData] = useState<Document>();
  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getDocuments())) as unknown as Document;
        setDocumentsData(response as Document);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  const docData = APPLICATION_TYPE_FOR_DOCUMENTS.PHYGITAL;

  const documents =
    typeof documentsData !== 'undefined'
      ? (((documentsData as Document)[docData] || []) as any)
      : [];

  const ligalityDocument = documents
    ?.filter((doc: documentProps) => doc?.documentType === 'phygitalDocument')
    ?.map((doc: documentProps) => {
      const baseDocument = {
        documentType: doc?.documentType,
        documentName: doc?.documentName,
        multipleFiles: doc?.multipleFiles,
        required: doc?.required,
        options: doc?.options,
        infoText: doc?.infoText,
        downloadTemplate: doc?.downloadTemplate,
        file: signedLeegalityFile?.id ? signedLeegalityFile : undefined,
      };

      return {
        ...baseDocument,
        documentsList: [{ ...baseDocument, documentsList: doc?.documentsList }],
      };
    });

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
              mt={5}>
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', mb: 2 }}>
                Phygital Documents Details
              </Typography>
            </Box>

            {!signedLeegalityFile?.id && (
              <Grid
                xs={12}
                sm={12}
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'common.black',
                  textAlign: 'center',
                  my: 3,
                }}>
                No Documents
              </Grid>
            )}
            <Grid
              container
              pt={signedLeegalityFile?.id && 2}
              pb={signedLeegalityFile?.id && 5}
              columnSpacing={13}
              sx={{ pl: { xs: 0, sm: 7, md: 10, lg: 13 }, display: 'flex', alignItems: 'center' }}>
              {ligalityDocument?.map((_doc: documentDetails, index: number) => {
                const { documentName, file } = _doc;
                return (
                  <React.Fragment key={index}>
                    <Grid item xs={12} sm={6} md={file ? 6 : 12} sx={{ mt: index !== 0 ? 6 : 0 }}>
                      <Item>{documentName}</Item>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Box
                        sx={{
                          display: 'flex',
                          mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                          flexDirection: { sm: 'column', xs: 'row', md: 'row' },
                        }}>
                        <Button
                          variant="contained"
                          sx={{
                            color: 'common.white',
                            minWidth: '70%',
                            fontWeight: 600,
                            lineHeight: 1.5,
                          }}
                          onClick={() => window.open(file?.viewUrl)}>
                          View
                        </Button>
                        <Tooltip title={'Download'}>
                          <IconButton
                            sx={{
                              ':hover': {
                                bgcolor: '#F4FCFC',
                              },
                              cursor: 'pointer',
                              pointerEvents: 'all',
                            }}
                            onClick={() => window.open(file?.url)}>
                            <CardMedia
                              component="img"
                              src={'/images/download-icon.png'}
                              alt="Download"
                              sx={{ width: '25px' }}
                            />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Grid>
                  </React.Fragment>
                );
              })}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
